import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./index.scss";

const LazyImage = ({ alt, src }) => (
  <div className="lazy-image">
    <LazyLoadImage alt={alt} effect="blur" src={src} />
  </div>
);

export default LazyImage;
